var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.titleType,{tag:"component",staticClass:"plugin-infopage-title",class:'_' + _vm.titleType},[_c('div',{staticClass:"plugin-infopage-title__text-wrapper"},[_c('span',{staticClass:"plugin-infopage-title__text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }